import { store } from 'store';
import { ChatUserModel } from 'types/chat-users/chat-user';

/** CompanyId מה-store — אותה עדיפות כמו contact-mapper (company ואז user). */
export function resolveStoreCompanyId(): string {
  const state = store.getState();
  return state.company?.CompanyId || state.user?.CompanyId || '';
}

/** מחזיר true כשיש CompanyID שונה מזה של הסשן (שיחה זרה — לא race). */
export function isForeignChatUserCompany(
  chatUser: ChatUserModel,
  companyId?: string,
): boolean {
  const cid = companyId ?? resolveStoreCompanyId();
  return Boolean(chatUser.CompanyID && cid && chatUser.CompanyID !== cid);
}

/** חותם CompanyID חסר כשהסשן כבר יודע את החברה הפעילה (מרוץ טעינת רשימה). */
export function repairChatUserCompanyIdIfEmpty(
  chatUser: ChatUserModel,
  companyId?: string,
): ChatUserModel {
  const cid = companyId ?? resolveStoreCompanyId();
  if (!cid || chatUser.CompanyID) return chatUser;
  return { ...chatUser, CompanyID: cid };
}
